const ValidationMixin = {
  methods: {
    /**
     * Accepts a paired list of Vuelidate properties and associated error messages, and returns an error message for
     * any that fail. Intended to work transparently with the :error-messages property in Vuetify components.
     *
     * @param validations A list of pairs of Vuelidate properties and their associated error messages. The structure is:
     * {
     *   prop: this.$v.yourPropertyHere,          // The vuelidate property to evaluate
     *   rule: 'ruleName'                         // The optional rule name. If none provided, will trip on any failed
     *                                            // validation rule.
     *   message: 'Your error message goes here', // This is the error message that will be returned
     * }
     * @returns {Array} an array of error messages, or an empty array if no errors found.
     */
    validationErrors (validations) {
      const errors = []
      for (const v of validations) {
        // Check if any rules errored on the specified prop
        if (v.prop.$dirty && v.prop.$error) {
          if (v.rule != null) {
            // If a rule was specified, evaluate it
            if (v.prop[v.rule] === false) {
              errors.push(v.message)
            }
          } else {
            // No validation rule to distinguish, so return an error.
            errors.push(v.message)
          }
        }
      }
      return errors
    },
    /**
     * Wrapper for validationErrors to evaluate a single validation.
     * @param {Object} validation The single validation to evaluate. See validationErrors() for structure.
     * @returns {*}
     */
    validationError (validation) {
      return this.validationErrors([validation])
    },

    /**
     * Return whether the given Vuelidate property is in an error state.
     * @param prop
     * @returns boolean
     */
    hasError (prop) {
      return prop.$dirty && prop.$error
    }
  }
}

export default ValidationMixin
